The type of country subdivision.

Currently, one code is defined:

- `State` indicates a state, province, or territory.
